
import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import HtlAgnSeaReduction from "./HtlAgnSeaReduction";


import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_PER_BASE = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
    $contSeaIdSeq: Int,
    $basePeriod: String,
    $roomType: String,
    
    

  ) {
    tbl_cont_per_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
        sea_id: { _eq: $contSeaIdSeq },
        period: { _eq: $basePeriod },
        room_type: { _eq: $roomType },
      },
      order_by: { room_type: asc } 
    ) {   
      cont_id
      sea_id
      per_id
      room_class
      room_type
      get_room_name {
        r_type_name
      }
      base_price
      period
      currency
      release
      min_stay
    }
  }
`;

const UPDATE_BASE_PRICE = gql`
mutation UpdateContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $contSeaIdSeq: Int
  $basePeriod: String
  $roomType: String
  $basePrice: float8! 
  
) {
  update_tbl_cont_per_base(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
      sea_id: { _eq: $contSeaIdSeq }
      period: { _eq: $basePeriod }
      room_type: { _eq: $roomType }
    },
    _set: {
     base_price: $basePrice,
     
    }
  ) {
    affected_rows
  }
}
`;



const HtlAgnSeasonPriceEdit = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang } = users;
    const { id_seq } = useParams();
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const {varCode7, setVarCode7} = useContext(ThemeContext);
  
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en'; 
   
  
   
  
    const { loading, error, data, refetch } = useQuery(GET_PER_BASE, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4,
                   contSeaIdSeq: varCode3, basePeriod: varCode6, roomType: varCode7  },
    });
  
    
     
 
  
  
    const firmData = data && data.tbl_cont_per_base ? data.tbl_cont_per_base[0] : null;

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.sea_id :"");
    const [perId, setPerId] = useState(firmData ? firmData.per_id :"");
   // const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  //  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());


    const [basePeriod, setBasePeriod] = useState(firmData ? firmData.period :"");
    const [roomType, setRoomType] = useState(firmData ? firmData.room_type :"");
    const [roomName, setRoomName] = useState(firmData ? firmData.get_room_name.r_type_name :"");
    const [roomClass, setRoomClass] = useState(firmData ? firmData.room_class :"");
    
    const [basePrice, setBasePrice] = useState(firmData ? firmData.base_price :"");
    const [minStay, setMinStay] = useState(firmData ? firmData.min_stay :"");
    const [release, setRelease] = useState(firmData ? firmData.release :"");
    const [currency, setCurrency] = useState(firmData ? firmData.currency :"");

    

   
   // const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  //  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

    
    const [UpdateContBasePrice] = useMutation(UPDATE_BASE_PRICE);

    
    useEffect(() => {
    
        refetch();  
       
        console.log('Sayfa açıldı!');
        
        // componentWillUnmount
        return () => {
          console.log('Sayfa kapatılıyor...');
          refetch();  
         
        };
      }, []);

  




  const handleBasePriceUpdate = () => {
    UpdateContBasePrice({
      variables: {
        contIdSeq: contIdSeq,
        contSeaIdSeq: contSeaIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        basePeriod: basePeriod,
        roomType: roomType,
        basePrice: basePrice,
       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
        refetch();
        
      
       
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  };

  


    

    useEffect(() => {
        if (firmData) {  
               

          
          setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.sea_id);
          setPerId(firmData.per_id);
          setBasePeriod(firmData.period);
          setRoomClass(firmData.room_class);
          setRoomType(firmData.room_type);
          setBasePrice(firmData.base_price);
          setRoomName(firmData.get_room_name.r_type_name);
          setMinStay(firmData.min_stay);
          setRelease(firmData.release);
          setCurrency(firmData.currency);
          
       //   setStartDate(new Date(firmData.start_date).toLocaleDateString());
      //    setEndDate(new Date(firmData.end_date));
          refetch();  
          
    
        }
      }, [firmData]);

   


  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
  
    return (
        <>
          <Fieldset>
            <div className="flex">
              <div className="mr-2 w-1/3">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Id"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={contIdSeq}
                  onValueChange={(e) => setContIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>
              <div className="mr-2 w-1/3">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Sea Id"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={contSeaIdSeq}
                  onValueChange={(e) => setContSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>
              <div className="mr-2 w-1/3">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Period Id"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={perId}
                  onValueChange={(e) => setPerId(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>     

               <div className="mr-2 w-1/3">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Period"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={basePeriod}
                  onValueChange={(e) => setBasePeriod(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>                       
             </div>
             
             <div className="flex gap-4">
               <div className="w-1/5 gap-3">
               <label className="block font-medium text-gray-950 justify-content-center gap-4"
                htmlFor="username">  {"Room Class"}</label>
               <InputText className="h-11  w-full" 
               id="username" value={roomClass}
               onChange={(e) => setRoomClass(e.target.value)}
               />
             </div>
            
               <div className="w-1/5 gap-3">
               <label className="block font-medium text-gray-950 justify-content-center gap-4"
                htmlFor="username">  {"Room Type"}</label>
               <InputText className="h-11  w-full" 
               id="username" value={roomType}
               onChange={(e) => setRoomType(e.target.value)}
               />
             </div>
             <div className="w-3/5 gap-3">
               <label className="block font-medium text-gray-950 justify-content-center gap-4"
                htmlFor="username">  {"Room Name"}</label>
               <InputText className="h-11  w-full" 
               id="username" value={roomName}
               onChange={(e) => setRoomName(e.target.value)}
               />
             </div>

             </div>


             <div className="flex gap-4">
               <div className="w-1/5 gap-3">
               <label className="block font-medium text-gray-950 justify-content-center gap-4"
                htmlFor="username">  {"Min Stay"}</label>
               <InputText className="h-11  w-full" 
               id="username" value={minStay}
               onChange={(e) => setMinStay(e.target.value)}
               />
             </div>
            
               <div className="w-1/5 gap-3">
               <label className="block font-medium text-gray-950 justify-content-center gap-4"
                htmlFor="username">  {"Release"}</label>
               <InputText className="h-11  w-full" 
               id="username" value={release}
               onChange={(e) => setRelease(e.target.value)}
               />
             </div>

             <div className="mr-2 w-1/3">
          <label htmlFor="firmType" className="block font-medium text-gray-700">
            {"Price"}
          </label>
          <InputNumber
            inputId="integeronly"
            useGrouping={true}
            value={basePrice}
            onValueChange={(e) => setBasePrice(e.target.value)}
            className="w-full h-11 font-extrabold border-gray-300 rounded-md"
            maxFractionDigits={2}            
            locale="tr"
           />                
        </div>     

           
             <div className="w-1/5 gap-3">
               <label className="block font-medium text-gray-950 justify-content-center gap-4"
                htmlFor="username">  {"Currency"}</label>
               <InputText className="h-11  w-full" 
               id="username" value={currency}
               onChange={(e) => setCurrency(e.target.value)}
               />
             </div>

             </div>
           
        
       <button
        className="bg-violet-900 mt-4 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleBasePriceUpdate}
      >
        {"Update Base Price"}
      </button>
          </Fieldset>
      
         
      
          
        </>
      );
      
  };
  
  export default HtlAgnSeasonPriceEdit;

  /*       <div className="mr-2 w-1/5">
          <label htmlFor="firmType" className="block font-medium text-gray-700">
            {"Cont Id"}
          </label>
          <InputNumber
            inputId="integeronly"
            useGrouping={false}
            value={basePrice}
            onValueChange={(e) => setBasePrice(e.value)}
            className="w-full h-11 border-gray-300 rounded-md"
            
          />                
        </div>*/
